import { render, staticRenderFns } from "./AS_Contact.vue?vue&type=template&id=a134efc6&scoped=true&"
import script from "./AS_Contact.vue?vue&type=script&lang=js&"
export * from "./AS_Contact.vue?vue&type=script&lang=js&"
import style0 from "./AS_Contact.vue?vue&type=style&index=0&id=a134efc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a134efc6",
  null
  
)

export default component.exports